// Attachment Type — a property characteristic POINT keeps separate from Property
// Type. Values are the MISMO 3.4 AttachmentType enum, so the exporter can emit
// them directly. Empty value renders as "Select..." in the dropdown.
export const ATTACHED = "Attached";
export const DETACHED = "Detached";

export default Object.freeze({
  [ATTACHED]: "Attached",
  [DETACHED]: "Detached"
});
